/* eslint-disable no-unused-expressions */
import { createGlobalStyle } from 'styled-components';
import theme from 'shared/style/theme';
import { upToMedia } from 'shared/style/media';

const { primaryColor } = theme;

const CookiesStyle = createGlobalStyle`

  #CybotCookiebotDialogBody {
    max-width: 1030px !important;
    padding: 0 8rem !important;
  }

  #CybotCookiebotDialogBodyContentTitle {
    color: ${primaryColor} !important;
    font-size: 3.8rem !important;
    margin-bottom: 2rem !important;
  }
  #CybotCookiebotDialogBodyContentText {
    font-size: 1.8rem;
  }

  #CybotCookiebotDialogPoweredbyLink {
     display: none !important;
  }

  #CybotCookiebotDialogBodyContent {
    padding-top: 20px !important;
    padding-left: 0 !important;
    padding-bottom: 0 !important;
  }

  #CybotCookiebotDialogBodyLevelButtons {
    margin-left: 0 !important;
  }
  
  a#CybotCookiebotDialogBodyLevelButtonAccept {
    background-color: ${primaryColor} !important;
    border: ${primaryColor} !important;
    border-radius: 6px !important;
    min-width: 100px !important;
    padding: 10px 10px !important;
  }

  #CybotCookiebotDialogBodyLevelDetailsWrapper {
    height: 30px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    white-space: nowrap;
  }

  #CybotCookiebotDialogBodyLevelButtonsSelectPane {
    border: none !important;
  }

  input[type=checkbox].CybotCookiebotDialogBodyLevelButton+label {
    font-size: 2rem;
    padding-left: 25px !important; 
  }

  #CybotCookiebotDialogBodyLevelDetailsWrapper {
    border: none !important;
    background-color: none !important;
  }

  .CybotCookiebotDialogBodyLevelButtonWrapper {
     margin-right: 20px !important;
  }

  #CybotCookiebotDialog p {
    line-height: 1.5 !important;

  }

  #CybotCookiebotDialogBodyLevelButtonsSelectPane {
    padding-left: 0 !important;
  }
  

  input[type=checkbox]+label {
    position: relative;
    transition: all 200ms;
  }

  #CybotCookiebotDialogBodyLevelButtonsTable {
    float: left;
  }

  #CybotCookiebotDialogBodyLevelWrapper {

    ${upToMedia.tablet`
    display: flex !important;
    flex-direction: column-reverse;
  `}

  }

  ${'' /* .CookieDeclaration {
    display: none !important;
  } */}
 

`;

export default CookiesStyle;
